module.exports = __webpack_public_path__ + "img/method_payplug.f816b837.svg";